// ACTION TYPES //
export const LOAD_PROPERTY_PHOTO = 'clapi/load-property-photo'
export const LOAD_PROPERTY_PHOTO_FINISHED = 'clapi/load-property-photo-finished'
export const LOAD_PROPERTY_PHOTO_FAILED = 'clapi/load-property-photo-failed'
export const RESET_PROPERTY_PHOTO = 'clapi/reset-property-photo'

export const LOAD_PROPERTY_SUMMARY = 'clapi/load-property-summary'
export const LOAD_PROPERTY_SUMMARY_FINISHED = 'clapi/load-property-summary-finished'
export const LOAD_PROPERTY_SUMMARY_FAILED = 'clapi/load-property-summary-failed'
export const RESET_PROPERTY_SUMMARY = 'clapi/reset-property-summary'

export const LOAD_VALUATION_ESTIMATES = 'clapi/load-valuation-estimates'
export const LOAD_VALUATION_ESTIMATES_FINISHED = 'clapi/load-valuation-estimates-finished'
export const LOAD_VALUATION_ESTIMATES_FAILED = 'clapi/load-valuation-estimates-failed'
export const RESET_VALUATION_ESTIMATES = 'clapi/reset-valuation-estimates'

export const LOAD_RATING_VALUATION = 'clapi/load-rating-valuation'
export const LOAD_RATING_VALUATION_FINISHED = 'clapi/load-rating-valuation-finished'
export const LOAD_RATING_VALUATION_FAILED = 'clapi/load-rating-valuation-failed'
export const RESET_RATING_VALUATION = 'clapi/reset-rating-valuation'

export const LOAD_RECORD_OF_TITLE_DETAILS = 'clapi/load-record-of-title-details'
export const LOAD_RECORD_OF_TITLE_DETAILS_FINISHED = 'clapi/load-record-of-title-details-finished'
export const LOAD_RECORD_OF_TITLE_DETAILS_FAILED = 'clapi/load-record-of-title-details-failed'
export const RESET_RECORD_OF_TITLE_DETAILS = 'clapi/reset-record-of-title-details'

export const LOAD_DISCLAIMER = 'clapi/load-disclaimer'
export const LOAD_DISCLAIMER_FINISHED = 'clapi/load-disclaimer-finished'
export const LOAD_DISCLAIMER_FAILED = 'clapi/load-disclaimer-failed'

export const LOAD_COPYRIGHT = 'clapi/load-copyright'
export const LOAD_COPYRIGHT_FINISHED = 'clapi/load-copyright-finished'
export const LOAD_COPYRIGHT_FAILED = 'clapi/load-copyright-failed'

export const LOAD_PROPERTY_TIMELINE = 'clapi/load-property-timeline'
export const LOAD_PROPERTY_TIMELINE_FINISHED = 'clapi/load-property-timeline-finished'
export const LOAD_PROPERTY_TIMELINE_FAILED = 'clapi/load-property-timeline-failed'
export const RESET_PROPERTY_TIMELINE = 'clapi/reset-property-timeline'

export const LOAD_COMPARABLE_PROPERTIES = 'clapi/load-comparable-properties'
export const LOAD_COMPARABLE_PROPERTIES_FINISHED = 'clapi/load-comparable-properties-finished'
export const LOAD_COMPARABLE_PROPERTIES_FAILED = 'clapi/load-comparable-properties-failed'
export const RESET_COMPARABLE_PROPERTIES = 'clapi/reset-comparable-properties'

export const LOAD_LOCAL_SCHOOLS = 'clapi/load-local-schools'
export const LOAD_LOCAL_SCHOOLS_FINISHED = 'clapi/load-local-schools-finished'
export const LOAD_LOCAL_SCHOOLS_FAILED = 'clapi/load-local-schools-failed'
export const RESET_LOCAL_SCHOOLS = 'clapi/reset-local-schools'

export const LOAD_MARKET_INSIGHTS = 'clapi/load-market-insights'
export const LOAD_MARKET_INSIGHTS_FINISHED = 'clapi/load-market-insights-finished'
export const LOAD_MARKET_INSIGHTS_FAILED = 'clapi/load-market-insights-failed'
export const RESET_MARKET_INSIGHTS = 'clapi/reset-market-insights'
export const LOAD_MAP = 'clapi/load-map'
export const LOAD_MAP_FINISHED = 'clapi/load-map-finished'
export const LOAD_MAP_FAILED = 'clapi/load-map-failed'
export const RESET_MAP = 'clapi/reset-map'

// ACTIONS //
export const loadPropertyPhoto = (code) => ({
  type: LOAD_PROPERTY_PHOTO,
  payload: code
})

export const loadPropertyPhotoFinished = (data) => ({
  type: LOAD_PROPERTY_PHOTO_FINISHED,
  payload: data
})

export const loadPropertyPhotoFailed = (statusCode) => ({
  type: LOAD_PROPERTY_PHOTO_FAILED,
  payload: statusCode
})

export const loadPropertySummary = (code) => ({
  type: LOAD_PROPERTY_SUMMARY,
  payload: code
})

export const loadPropertySummaryFinished = (data) => ({
  type: LOAD_PROPERTY_SUMMARY_FINISHED,
  payload: data
})

export const loadPropertySummaryFailed = (statusCode) => ({
  type: LOAD_PROPERTY_SUMMARY_FAILED,
  payload: statusCode
})

export const loadValuationEstimates = (code) => ({
  type: LOAD_VALUATION_ESTIMATES,
  payload: code
})

export const loadValuationEstimatesFinished = (data) => ({
  type: LOAD_VALUATION_ESTIMATES_FINISHED,
  payload: data
})

export const loadValuationEstimatesFailed = (statusCode) => ({
  type: LOAD_VALUATION_ESTIMATES_FAILED,
  payload: statusCode
})

export const loadRatingValuation = (code) => ({
  type: LOAD_RATING_VALUATION,
  payload: code
})

export const loadRatingValuationFinished = (data) => ({
  type: LOAD_RATING_VALUATION_FINISHED,
  payload: data
})

export const loadRatingValuationFailed = (statusCode) => ({
  type: LOAD_RATING_VALUATION_FAILED,
  payload: statusCode
})

export const loadRecordOfTitleDetails = code => ({
  type: LOAD_RECORD_OF_TITLE_DETAILS,
  payload: code
})

export const loadRecordOfTitleDetailsFinished = (data) => ({
  type: LOAD_RECORD_OF_TITLE_DETAILS_FINISHED,
  payload: data
})

export const loadRecordOfTitleDetailsFailed = (statusCode) => ({
  type: LOAD_RECORD_OF_TITLE_DETAILS_FAILED,
  payload: statusCode
})

export const resetPropertyPhoto = () => ({
  type: RESET_PROPERTY_PHOTO
})

export const resetPropertySummary = () => ({
  type: RESET_PROPERTY_SUMMARY
})

export const resetValuationEstimates = () => ({
  type: RESET_VALUATION_ESTIMATES
})

export const resetRatingValuation = () => ({
  type: RESET_RATING_VALUATION
})

export const resetRecordOfTitleDetails = () => ({
  type: RESET_RECORD_OF_TITLE_DETAILS
})

export const loadDisclaimer = (code) => ({
  type: LOAD_DISCLAIMER,
  payload: code
})

export const loadDisclaimerFinished = (data) => ({
  type: LOAD_DISCLAIMER_FINISHED,
  payload: data
})

export const loadDisclaimerFailed = (statusCode) => ({
  type: LOAD_DISCLAIMER_FAILED,
  payload: statusCode
})

export const loadCopyright = (code) => ({
  type: LOAD_COPYRIGHT,
  payload: code
})

export const loadCopyrightFinished = (data) => ({
  type: LOAD_COPYRIGHT_FINISHED,
  payload: data
})

export const loadCopyrightFailed = (statusCode) => ({
  type: LOAD_COPYRIGHT_FAILED,
  payload: statusCode
})

export const loadPropertyTimeline = (payload) => ({
  type: LOAD_PROPERTY_TIMELINE,
  payload
})

export const loadPropertyTimelineFinished = (payload) => ({
  type: LOAD_PROPERTY_TIMELINE_FINISHED,
  payload
})

export const loadPropertyTimelineFailed = (payload) => ({
  type: LOAD_PROPERTY_TIMELINE_FAILED,
  payload
})

export const resetPropertyTimeline = () => ({
  type: RESET_PROPERTY_TIMELINE
})

export const loadComparableProperties = (code) => ({
  type: LOAD_COMPARABLE_PROPERTIES,
  payload: code
})

export const loadComparablePropertiesFinished = (data) => ({
  type: LOAD_COMPARABLE_PROPERTIES_FINISHED,
  payload: data
})

export const loadComparablePropertiesFailed = (statusCode) => ({
  type: LOAD_COMPARABLE_PROPERTIES_FAILED,
  payload: statusCode
})

export const resetComparableProperties = () => ({
  type: RESET_COMPARABLE_PROPERTIES
})

export const loadLocalSchools = (code) => ({
  type: LOAD_LOCAL_SCHOOLS,
  payload: code
})

export const loadLocalSchoolsFinished = (data) => ({
  type: LOAD_LOCAL_SCHOOLS_FINISHED,
  payload: data
})

export const loadLocalSchoolsFailed = (statusCode) => ({
  type: LOAD_LOCAL_SCHOOLS_FAILED,
  payload: statusCode
})

export const resetLocalSchools = () => ({
  type: RESET_LOCAL_SCHOOLS
})

export const loadMarketInsights = (payload) =>
  ({ type: LOAD_MARKET_INSIGHTS, payload })
export const loadMarketInsightsFinished = (payload) =>
  ({ type: LOAD_MARKET_INSIGHTS_FINISHED, payload })
export const loadMarketInsightsFailed = (payload) =>
  ({ type: LOAD_MARKET_INSIGHTS_FAILED, payload })
export const resetMarketInsights = (payload) =>
  ({ type: RESET_MARKET_INSIGHTS, payload })
export const loadMap = (code) => ({
  type: LOAD_MAP, payload: code
})

export const loadMapFinished = (data) => ({
  type: LOAD_MAP_FINISHED,
  payload: data
})

export const loadMapFailed = (statusCode) => ({
  type: LOAD_MAP_FAILED,
  payload: statusCode
})

export const resetMap = () => ({
  type: RESET_MAP
})
